export default "<ng2-smart-table [settings]=\"settings\" [source]=\"companyGroupsList\" (delete)=\"deleteGroups($event)\">\r\n</ng2-smart-table>";